export default class Settings {
	static settings = {}

	static setSettings(settings, group) {
		if(typeof group == null) {
			group = 'default';
		}

		if(Settings.settings[group] == null) {
			Settings.settings[group] = {};
		}

		Settings.settings[group] = Object.assign(Settings.settings[group], settings);
	}

	static getSetting(setting_key, group) {
		if(typeof group === 'undefined') {
			group = 'default';
		}

		return Settings.settings?.[group]?.[setting_key]
	}
}